import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Option } from '../../inputs/select/options';

@Component({
  selector: 'app-cms-entity-management-nav',
  templateUrl: './cms-entity-management-nav.component.html',
  styleUrls: ['./cms-entity-management-nav.component.scss'],
})
export class CmsEntityManagementNavComponent {
  @Input() options: Option[] = [];
  @Input() activeOption: string;

  @Output()
  changeActiveOption: EventEmitter<string | number> = new EventEmitter<
    string | number
  >();
}
